import React from 'react';
const PopupInner = (props) => (React.createElement("div", Object.assign({}, props)));
export default PopupInner;
